import axios from "axios"
import { GetAllProvinciasDtoProps } from "./DTOs/GetAllProvinciasDto"
import { GetAllProvinciasDtoAdapter } from "./Provincia.adapter"
import { GetAllProvinciasDtoIPagedEnumerableProps } from "./Schemas/GetAllProvinciasDtoIPagedEnumerable"

export async function GetAllProvinciasDtoIPagedEnumerable(): Promise<GetAllProvinciasDtoIPagedEnumerableProps> {
  const { data } = await axios.get("/Provincia")
  return {
    currentPage: data?.currentPage,
    items: data.items?.map((item: GetAllProvinciasDtoProps) =>
      GetAllProvinciasDtoAdapter(item)
    ),
    totalCount: data?.totalCount,
  }
}
